import React, { useCallback } from 'react';
import range from 'lodash/range';
import Placeholder from '../Placeholder';
import TitlePlaceholder from '../TitlePlaceholder';
import Grid from '../../../Grid/MeasuredGrid';
import { MeasuredCookieType } from '../../../Measured';
import s from './LoaderBlock.scss';
const items = range(0, 9);
const LoaderBlock = ({ index })=>{
    const renderItem = useCallback(({ height, width, index: itemIndex, style })=>{
        return /*#__PURE__*/ React.createElement("div", {
            key: itemIndex,
            style: style
        }, /*#__PURE__*/ React.createElement(Placeholder, {
            width: width,
            height: height
        }));
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['block-header']
    }, /*#__PURE__*/ React.createElement(TitlePlaceholder, {
        splitIndex: index
    })), /*#__PURE__*/ React.createElement(Grid, {
        lazyloadFromContext: true,
        enableScrollOptim: false,
        containerWidth: 308,
        defaultSize: {
            desktop: {
                width: 308,
                height: 308
            },
            mobile: {
                width: 308,
                height: 308
            }
        },
        cookieType: MeasuredCookieType.DEVIATION_SIDEBAR,
        maxRows: 3,
        breakpoints: [
            {
                maxWidth: 600,
                elementsPerRow: 3,
                elementAspectRatio: 1
            }
        ],
        spacing: 16,
        elementCount: items.length,
        renderElement: renderItem
    }));
};
LoaderBlock.displayName = 'LoaderBlock';
export default LoaderBlock;
